




















































































import Vue from 'vue';
import _ from 'lodash';
import { items as galleryList } from '@/assets/data/gallery_list.json';
export default Vue.extend({
	name: 'Home',
	data: function() {
		return {
			galleryBuilded: [] as Array<Array<object>>,
		};
	},
	mounted: function(): void {
		this.buildGallery(galleryList);
	},
	methods: {
		buildGallery: function(galleryItems: Array<object>) {
			const chunkedItems = _.chunk(galleryItems, 2);
			this.galleryBuilded = chunkedItems;
		},
	},
});
